import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

export const CardUsageLimits = () => {
    return (
        <div className="flex flex-col gap-2xl">
            <Text className="m-0 text-2xl font-bold text-primary-10 max-sm:text-l">
                <FormattedMessage
                    id="_.credit_card.dashboard.card_usage_limits.title"
                    defaultMessage="Card usage limits"
                />
            </Text>
            <div className="flex flex-col gap-m">
                <Text className="font-medium m-0 text-m text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.transaction_limits.title"
                        defaultMessage="Transaction limits"
                    />
                </Text>
                <Text className="text-neutral-60 m-0 text-xs">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.transaction_limits.label"
                        defaultMessage="The number of transactions you can make with your card."
                    />
                </Text>
                <div className="flex flex-col gap-s">
                    <Text className="m-0 text-m text-primary-10">
                        <FormattedMessage
                            id="_.credit_card.dashboard.card_usage_limits.transaction_limits.month"
                            defaultMessage="5 per day"
                        />
                    </Text>
                </div>
            </div>
            <div className="flex flex-col gap-m">
                <Text className="font-medium m-0 text-m text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.spending_limits.title"
                        defaultMessage="Spending limits"
                    />
                </Text>
                <div className="flex flex-col gap-s">
                    <Text className="m-0 text-m text-primary-10">
                        <FormattedMessage
                            id="_.credit_card.dashboard.card_usage_limits.spending_limits.month"
                            defaultMessage="£750 per day"
                        />
                    </Text>
                </div>
            </div>
            <div className="flex flex-col gap-m">
                <Text className="font-medium m-0 text-m text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.card_fees.title"
                        defaultMessage="Card fees"
                    />
                </Text>
                <Text className="m-0 text-m text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.card_fees.replacement"
                        defaultMessage="Card replacement fee £0"
                    />
                </Text>
                <Text className="m-0 text-m text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.card_fees.monthly"
                        defaultMessage="Monthly fee £0"
                    />
                </Text>
                <Text className="m-0 text-m text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.card_fees.fx"
                        defaultMessage="FX fee £0"
                    />
                </Text>
                <Text className="m-0 text-m text-primary-10">
                    <FormattedMessage
                        id="_.credit_card.dashboard.card_usage_limits.card_fees.chargeback"
                        defaultMessage="Chargeback handling fee £0"
                    />
                </Text>
            </div>
        </div>
    );
};
